export default {};



// WEBPACK FOOTER //
// ./src/store/translators/actions.js